<div
  [style.height]="height"
  class="loading d-flex justify-content-center align-items-center"
  id="splash-screen"
>
  <img
    alt="Yuklanmoqda..."
    src="./assets/media/logos/green-spinner.svg"
    width="80"
  />
</div>
